<template>
  <v-menu
    v-if="isVisible"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        classB="min-width-200 font-weight-bold"
        color="primary"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-brain</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item :to="{ name: 'IAChat' }">
        <v-list-item-icon>
          <v-icon>mdi-message-text</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Chat IA</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'IAReport' }">
        <v-list-item-icon>
          <v-icon>mdi-file-chart-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Report IA</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "ChatIAButton",
  computed: {
    companyId() {
      return this.$store.state.app.company?.pk
    },
    projectId() {
      return this.$store.state.app.project?.id
    },
    isVisible() {
      return !!this.companyId && !!this.projectId
    }
  }
}
</script>
